module.exports = __webpack_public_path__ + "img/ok.208035eb.png";